import { atom } from "recoil";

export const uploadFileListAtom = atom({
  key: "upload-file-list",
  default: { status: "initial", data: [] },
});
